import { showModal } from 'common/redux/modules/modals'

export const TICKET_DETAILS_DRAWER = 'TICKET_DETAILS_DRAWER'
export const PASSENGER_OPTIONS_MODAL = 'PASSENGER_OPTIONS_MODAL'
export const FARE_MENU_MODAL = 'FARE_MENU_MODAL'
export const FARE_MENU_DRAWER = 'FARE_MENU_DRAWER'
export const TICKET_SEARCH_EXPIRY_MODAL = 'TICKET_SEARCH_EXPIRY_MODAL'

export const showDetailsMobile = (el, callback, selected) =>
  showModal(
    TICKET_DETAILS_DRAWER,
    { el, callback, selected },
    true,
  )

export const showPassengerOptions = (el, callback, selected) =>
  showModal(
    PASSENGER_OPTIONS_MODAL,
    { el, callback, selected },
    true,
  )

export const showFareMenuModal = (el, callback, selected) =>
  showModal(
    FARE_MENU_MODAL,
    { el, callback, selected },
    true,
  )

export const showFareMenuDrawer = (el, callback, selected) =>
  showModal(
    FARE_MENU_DRAWER,
    { el, callback, selected },
    true,
  )

export const showTicketSearchExpiryModal = (el, callback, selected) =>
  showModal(
    TICKET_SEARCH_EXPIRY_MODAL,
    { el, callback, selected }
  )
